export default __webpack_public_path__ + "static/insta2-b05e9c6d2fa882a484a2a683389ab47b.jpg";